export default "__VITE_ASSET__DPPxXD9U__"